export default class SensorType {
  constructor () {
    this.source_id = ''
    this.description = ''
    this.variables = ''
  }
}